import styled from "styled-components";

export const MultiWeekPlannerMainContainer = styled("section")`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const EquipmentWrapper = styled.div`
  display: flex;
  flex: 0.8;
  flex-direction: column;
`;

export const EquipmentVerticalHeader = styled.div`
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  background-color: #f5f5f5;
`;

export const EquipmentHorizontalHeader = styled("div")`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  background-color: #cfd8dc;
`;

export const EquipmentRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 5em;
  font-size: 1.4em;
`;

export const EquipmentFigureValue = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  background-color: #eceff1;
  min-width: 5em;
  ${(props) =>
    props.highlighted &&
    `
    color: red;
    font-weight: bold;
  `};
`;
